/* Linsoul search dialog: new-site search surface on Shopify predictive search.
   Results markup comes from sections/ls-predictive-search.liquid. */
(function () {
  'use strict';
  if (window.LinsoulSearchCart && window.LinsoulSearchCart.openSearch) return;

  const host = document.getElementById('ls-searchcart31');
  const dialog = document.getElementById('sc31-search');
  if (!host || !dialog) return;

  const $ = (s, root = host) => root.querySelector(s);
  const $$ = (s, root = host) => Array.from(root.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();

  const input = $('#sc31-search-query');
  const inner = $('.overlay-inner', dialog);
  const resultsEl = $('#sc31-search-results');
  const sideEl = $('#sc31-suggestions-side');
  const idleTemplate = document.getElementById('sc31-search-idle');
  const idle = idleTemplate ? idleTemplate.content.querySelector('[data-ls-ps]') : null;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  const LIMIT_STEP = 8;
  const cache = new Map();
  let query = '';
  let category = 'all';
  let limit = LIMIT_STEP;
  let current = idle;
  let failed = false;
  let options = [];
  let activeIndex = -1;
  let timer = 0;
  let controller = null;
  let composing = false;
  let returnFocus = null;
  let closing = false;
  let motion = null;
  let previousOverflow = '';

  function fields() {
    let f = 'title,product_type,vendor,variants.sku,variants.title';
    if (dialog.dataset.searchByTag === 'true') f += ',tag';
    if (dialog.dataset.searchByBody === 'true') f += ',body';
    return f;
  }

  function suggestURL(q) {
    const p = new URLSearchParams();
    p.set('q', q);
    p.set('section_id', 'ls-predictive-search');
    p.set('resources[type]', 'product,collection,page,article,query');
    p.set('resources[limit]', '10');
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', dialog.dataset.unavailable || 'last');
    p.set('resources[options][fields]', fields());
    return (dialog.dataset.suggestUrl || '/search/suggest') + '?' + p.toString();
  }

  function searchURL(q) {
    return (dialog.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  async function fetchResults(q) {
    const key = norm(q);
    if (cache.has(key)) return cache.get(key);
    controller?.abort();
    controller = new AbortController();
    const res = await fetch(suggestURL(q), { signal: controller.signal, credentials: 'same-origin' });
    if (!res.ok) throw new Error('Search request failed: ' + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const data = doc.querySelector('[data-ls-ps]');
    if (!data) throw new Error('Search response missing results');
    cache.set(key, data);
    return data;
  }

  function group(src, key) {
    const list = src?.querySelector('[data-group="' + key + '"]');
    return list ? Array.from(list.children) : [];
  }

  function highlight(root, q) {
    const tokens = norm(q).split(' ').filter((t) => t.length > 0);
    if (!tokens.length) return;
    const re = new RegExp('(' + tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'ig');
    root.querySelectorAll('[data-highlight]').forEach((el) => {
      const text = el.textContent;
      el.innerHTML = text.split(re).map((part, i) => (i % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part))).join('');
    });
  }

  function clearActive() {
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
  }

  function render() {
    clearActive();
    const idleState = !query.trim();
    const src = idleState ? idle : current;
    const found = {
      products: group(src, 'products'),
      brands: group(src, 'brands'),
      guides: group(src, 'guides')
    };
    const tokens = norm(query).split(' ').filter((t) => t.length >= 3);
    const titleHit = (li) => {
      const title = norm((li.querySelector('[data-highlight]')?.textContent || '') + ' ' + (li.querySelector('.result-tech')?.textContent || ''));
      return tokens.some((t) => title.includes(t));
    };
    const pagesLead = !idleState && tokens.length > 0 && !found.products.some(titleHit)
      && (found.guides.some(titleHit) || found.brands.some(titleHit));
    let chosen = [category];
    if (category === 'all') {
      if (pagesLead) chosen = ['brands', 'guides', 'products'];
      else chosen = found.products.length ? ['products'] : ['brands', 'guides'];
    }
    const names = {
      products: idleState ? 'From the collection' : 'Products',
      brands: idleState ? 'Explore brands' : 'Brands',
      guides: 'Guides & help'
    };
    const selected = chosen.map((key) => ({ key, list: found[key] })).filter((x) => x.list.length);
    const heading = category === 'all'
      ? (idleState ? 'From the collection' : found.products.length && !pagesLead ? 'Products' : 'Pages & brands')
      : names[category];

    $('#sc31-results-heading').textContent = heading;
    $('#sc31-results-count').textContent = idleState || failed ? '' : selected.reduce((n, x) => n + x.list.length, 0) + ' matches';

    resultsEl.innerHTML = '';
    let index = 0;
    for (const { key, list } of selected) {
      const section = document.createElement('section');
      section.className = 'result-group';
      section.setAttribute('role', 'group');
      section.setAttribute('aria-label', names[key]);
      if (selected.length > 1) {
        const h = document.createElement('h3');
        h.className = 'result-group-heading';
        h.textContent = names[key];
        section.appendChild(h);
      }
      const ul = document.createElement('ul');
      ul.className = 'result-list' + (key === 'products' ? ' product-list' : '');
      ul.setAttribute('role', 'presentation');
      list.slice(0, limit).forEach((li) => {
        const clone = li.cloneNode(true);
        const option = clone.querySelector('[role="option"]');
        if (option) option.id = 'sc31-result-' + index++;
        ul.appendChild(clone);
      });
      section.appendChild(ul);
      resultsEl.appendChild(section);
    }
    if (!idleState) highlight(resultsEl, query);

    resultsEl.setAttribute('aria-busy', 'false');
    options = $$('[role="option"]', resultsEl);
    input.setAttribute('aria-expanded', String(dialog.open && options.length > 0));

    const empty = $('#sc31-empty-results');
    empty.hidden = options.length > 0;
    $('h3', empty).textContent = failed ? 'Search is unavailable right now.' : 'No matches yet.';
    $('p', empty).textContent = failed
      ? 'Press Enter or use View all results to search the full store.'
      : category === 'all'
        ? 'Try another product or brand name, or choose a suggestion.'
        : 'Try another search, or switch to All results.';

    $$('#sc31-search-categories button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.category === category)));
    $$('[data-count]', $('#sc31-search-categories')).forEach((el) => {
      el.textContent = idleState || failed ? '' : found[el.dataset.count].length;
    });

    const discovery = $('#sc31-search-discovery');
    if (discovery) discovery.hidden = !idleState;
    dialog.dataset.queryState = idleState ? 'idle' : 'typing';

    const more = $('#sc31-load-more');
    more.hidden = !selected.some((x) => x.list.length > limit);
    more.textContent = 'Show more ' + (chosen.length === 1 && chosen[0] === 'products' ? 'products' : 'results');

    renderSide(src, idleState);

    const total = found.products.length + found.brands.length + found.guides.length;
    $('#sc31-search-status').textContent = idleState
      ? 'Choose a suggested search or browse the collection.'
      : failed
        ? 'Search is unavailable right now.'
        : total + ' matches. ' + options.length + ' results shown in ' + heading + '. Related searches and destinations follow.';

    const all = $('#sc31-view-results');
    all.href = idleState ? all.dataset.browseHref : searchURL(query);
    $('[data-view-label]', all).textContent = idleState ? 'Browse all products' : 'View all results';
  }

  function renderSide(src, idleState) {
    sideEl.innerHTML = '';
    const side = src?.querySelector('[data-side]');
    if (side) sideEl.append(...Array.from(side.children).map((n) => n.cloneNode(true)));
    if (!idleState && !sideEl.querySelector('[data-explore]')) {
      const fallback = idle?.querySelector('[data-side] [data-explore]');
      if (fallback) sideEl.appendChild(fallback.cloneNode(true));
    }
    sideEl.hidden = !sideEl.textContent.trim();
  }

  function run(rev) {
    const q = query;
    if (!q.trim()) {
      failed = false;
      render();
      return;
    }
    resultsEl.setAttribute('aria-busy', 'true');
    fetchResults(q)
      .then((data) => {
        if (rev !== revision) return;
        current = data;
        failed = false;
        render();
      })
      .catch((err) => {
        if (err.name === 'AbortError' || rev !== revision) return;
        current = null;
        failed = true;
        render();
      });
  }

  let revision = 0;
  function setQuery(value, immediate = false) {
    query = String(value).slice(0, 120);
    input.value = query;
    limit = LIMIT_STEP;
    $('#sc31-clear-query').hidden = !query.trim();
    clearActive();
    const rev = ++revision;
    clearTimeout(timer);
    timer = 0;
    const discovery = $('#sc31-search-discovery');
    if (discovery) discovery.hidden = !!query.trim();
    if (immediate || cache.has(norm(query))) {
      run(rev);
      return;
    }
    resultsEl.setAttribute('aria-busy', 'true');
    timer = setTimeout(() => {
      timer = 0;
      if (rev === revision) run(rev);
    }, 150);
  }

  function flush() {
    if (timer) {
      clearTimeout(timer);
      timer = 0;
      run(revision);
    }
  }

  function resetScroll() {
    $('#sc31-results-scroller').scrollTop = 0;
    $('#sc31-search-scroll-shell').scrollTop = 0;
  }

  function changeCategory(next) {
    if (!['all', 'products', 'brands', 'guides'].includes(next)) return;
    category = next;
    limit = LIMIT_STEP;
    render();
    resetScroll();
  }

  function chooseOption(i) {
    if (!options.length) return;
    activeIndex = Math.max(0, Math.min(i, options.length - 1));
    options.forEach((o, n) => o.setAttribute('aria-selected', String(n === activeIndex)));
    input.setAttribute('aria-activedescendant', options[activeIndex].id);
    options[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  function cleanStyle(el) {
    ['transform', 'opacity', 'visibility'].forEach((k) => el.style.removeProperty(k));
  }

  function transition(leave, done) {
    motion?.kill?.();
    motion?.cancel?.();
    motion = null;
    const finish = () => {
      cleanStyle(inner);
      done?.();
    };
    if (reduced.matches) return finish();
    if (window.gsap) {
      motion = leave
        ? gsap.to(inner, { y: 8, autoAlpha: 0, duration: 0.14, ease: 'power2.in', overwrite: 'auto', onComplete: finish })
        : gsap.fromTo(inner, { y: 8, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.23, ease: 'power2.out', overwrite: 'auto', onComplete: finish });
    } else if (inner.animate) {
      const frames = [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }];
      motion = inner.animate(leave ? frames.slice().reverse() : frames, { duration: leave ? 140 : 230, easing: 'ease-out' });
      motion.finished.then(finish).catch(() => {});
    } else finish();
  }

  function triggers() {
    return $$('[data-sc31-open="search"],[data-open-search-popup]', document);
  }

  function updateTriggers() {
    triggers().forEach((el) => el.setAttribute('aria-expanded', String(dialog.open && !closing)));
  }

  function open(trigger, value) {
    if (value !== undefined) {
      category = 'all';
      setQuery(value, true);
      resetScroll();
    }
    if (dialog.open && !closing) {
      input.focus({ preventScroll: true });
      return;
    }
    window.dispatchEvent(new CustomEvent('linsoul:overlay-opening', { detail: { kind: 'search' } }));
    window.LinsoulUI?.closeTransient?.();
    const visible = (el) => el && el.isConnected && el.getClientRects().length;
    returnFocus = visible(trigger) ? trigger : triggers().find(visible) || document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    closing = false;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    transition(false);
    render();
    updateTriggers();
    input.focus({ preventScroll: true });
  }

  function close({ restore = true, immediate = false } = {}) {
    if (!dialog.open) return;
    const focus = returnFocus;
    const finish = () => {
      dialog.close();
      cleanStyle(inner);
      closing = false;
      returnFocus = null;
      document.documentElement.style.overflow = previousOverflow;
      input.setAttribute('aria-expanded', 'false');
      updateTriggers();
      if (restore && focus?.isConnected && focus.getClientRects().length) focus.focus({ preventScroll: true });
    };
    if (immediate || closing) {
      motion?.kill?.();
      motion?.cancel?.();
      finish();
      return;
    }
    closing = true;
    transition(true, finish);
  }

  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });
  dialog.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || composing || e.isComposing) return;
    e.preventDefault();
    e.stopPropagation();
    close();
  });
  dialog.addEventListener('click', (e) => {
    if (e.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
  });

  input.addEventListener('compositionstart', () => {
    composing = true;
    clearTimeout(timer);
    timer = 0;
    revision++;
  });
  input.addEventListener('compositionend', () => {
    composing = false;
    setQuery(input.value);
  });
  input.addEventListener('input', () => {
    if (!composing) setQuery(input.value);
  });
  input.addEventListener('keydown', (e) => {
    if (composing || e.isComposing) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      flush();
      const down = e.key === 'ArrowDown';
      chooseOption(activeIndex < 0 ? (down ? 0 : options.length - 1) : activeIndex + (down ? 1 : -1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && options[activeIndex]) options[activeIndex].click();
      else if (query.trim()) submit();
    }
  });

  function submit() {
    clearTimeout(timer);
    const url = searchURL(query);
    close({ restore: false, immediate: true });
    window.location.href = url;
  }

  $('#sc31-search-form').addEventListener('submit', (e) => {
    e.preventDefault();
    if (query.trim()) submit();
  });
  const reset = () => {
    category = 'all';
    setQuery('', true);
    resetScroll();
    input.focus();
  };
  $('#sc31-clear-query').addEventListener('click', reset);
  $('#sc31-reset-search').addEventListener('click', reset);
  $('#sc31-load-more').addEventListener('click', () => {
    const before = options.length;
    limit += 6;
    render();
    if (!$('#sc31-load-more').hidden) $('#sc31-load-more').focus({ preventScroll: true });
    else options[before]?.focus({ preventScroll: true });
  });

  const viewAll = $('#sc31-view-results');
  viewAll.dataset.browseHref = viewAll.getAttribute('href');

  host.addEventListener('click', (e) => {
    if (e.target.closest('[data-close]')) {
      close();
      return;
    }
    const cat = e.target.closest('[data-category]');
    if (cat) {
      changeCategory(cat.dataset.category);
      return;
    }
    const q = e.target.closest('[data-query]');
    if (q) {
      open(null, q.dataset.query);
      input.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('a[href]')) close({ restore: false, immediate: true });
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-sc31-open="search"],[data-open-search-popup]');
    if (!trigger || host.contains(trigger)) return;
    e.preventDefault();
    open(trigger);
  });

  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      open(triggers().find((el) => el.getClientRects().length));
    }
  });

  document.addEventListener('error', (e) => {
    const img = e.target;
    if (img.tagName === 'IMG' && img.closest('.result-photo')) img.hidden = true;
  }, true);

  window.MinimogEvents?.subscribe?.(window.MinimogTheme?.pubSubEvents?.openCartDrawer, () => close({ restore: false, immediate: true }));

  render();
  updateTriggers();

  window.LinsoulSearchCart = Object.assign(window.LinsoulSearchCart || {}, {
    openSearch: (value, trigger) => open(trigger, value),
    closeSearch: () => close({ immediate: true }),
    setCategory: changeCategory,
    getState: () => ({ query, category, activeIndex, shown: options.length, open: dialog.open, failed })
  });
  window.dispatchEvent(new CustomEvent('linsoul:searchcart-ready'));
})();
